/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
import * as ActionTypes from './ActionTypes';

// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});
export const dispatchMfgListOfMfgOut = (payload) => ({
  type: ActionTypes.SELECTED_MFG_OUT_BAL_MFG,
  payload,
});
//  error msg dispatch function
export const dispatchErrorMsgMfgOutStandingBalance = (data) => ({
  type: ActionTypes.GET_ERROR_MSG_MFG_OUTSTANDING_BALANCE,
  payload: data,
});

// To pass data from req screen to display screen
export const setSearchResult = (data) => {
  return {
    type: ActionTypes.SET_SELECTED_RESULT_MFG_OUTSTANDING_BALANCE,
    payload: data,
  };
};

//Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});
//Refresh Functinality
export const refreshMfgOustandingBalance = () => ({
  type: ActionTypes.REFRESH_MFG_OUTSTANDING_BALANCE,
  payload: {},
});

export const refreshMfgOustandingBalanceDisplay = () => ({
  type: ActionTypes.REFRESH_MFG_OUTSTANDING_BALANCE_DISPLAY,
  payload: {},
});
// To get plantype data
export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

//  get rebate programe Dropdown
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

//Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_MANUFACTURERS_OUTSTANDING_DISPUTES_QUARTER,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchResult({ errorMessages: [] }));
  // }, 5000);
  dispatch(
    setSearchResult({
      errorMessages: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

//API For Get the All rebate program
export const setManufacturerOutstandingBalHeader = (data) => ({
  type: ActionTypes.SET_MANUFACTURER_OUSTANDING_BALANCE_HEADER,
  payload: data,
});

export const getManufacturerOutstandingBalHeader = (values) => (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setManufacturerOutstandingBalHeader([]));
  return axios
    .post(serviceEndPoint.GET_MANUFACTURER_OUSTANDING_BALANCE_HEADER, values)
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(
        setManufacturerOutstandingBalHeader(
          response?.data?.manufacturerOutstandingBalanceHeaderGridReportVO
        )
      );
      return response?.data?.manufacturerOutstandingBalanceHeaderGridReportVO;
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setManufacturerOutstandingBalHeader([]));
    });
};

//API For Get the Data
export const setManufacturerOutstandingBalReport = (data) => ({
  type: ActionTypes.SET_MANUFACTURER_OUSTANDING_BALANCE_REPORT,
  payload: data,
});

export const setMfgOutstandingBalReportDataForExportAll = (
  data,
  rebateProgram
) => ({
  type: ActionTypes.SET_EXPORT_ALL_PDF_MFGO_OUTSTANTING_BAL,
  payload: { data, rebateProgram },
});

export const getManufacturerOutstandingBalReport = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_MANUFACTURER_OUSTANDING_BALANCE_REPORT, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (
        response?.data?.manufacturerOutstandingBalanceDisplayReportVO.length ===
        0
      ) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(
          setManufacturerOutstandingBalReport(
            response?.data?.manufacturerOutstandingBalanceDisplayReportVO
          )
        );
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setManufacturerOutstandingBalReport([]));
    });
};
export const reportData = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_MANUFACTURER_OUSTANDING_BALANCE_REPORT, values)
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setMfgOutstandingBalReportDataForExportAll(
          response?.data?.manufacturerOutstandingBalanceDisplayReportVO,
          values.rebateProgramCd
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(
        setMfgOutstandingBalReportDataForExportAll([], values.rebateProgramCd)
      );
    });
};
export const getMfgOutstandingBalReportDataForExportAll =
  ({ qtr, rebatePrograms, mfgId, aiAll }) =>
  (dispatch) => {
    for (let i = 0; i < rebatePrograms?.length; i++) {
      const values = {
        qtr,
        mfgId,
        aiAll,
        rebateProgramCd: rebatePrograms[i].rebateProgramCd,
      };

      dispatch(reportData(values));
    }
  };

export const setPaginationIndex = (value) => ({
  type: ActionTypes.SET_PAGINATION_INDEX_MANUFACTURER_OUSTANDING_BALANCE,
  payload: value,
});
